function DesignPackagePaths() {
  return (
    <>
      <path d="M19 9.5H11C10.4696 9.5 9.96086 9.71071 9.58579 10.0858C9.21071 10.4609 9 10.9696 9 11.5V25.5C9 26.0304 9.21071 26.5391 9.58579 26.9142C9.96086 27.2893 10.4696 27.5 11 27.5H25C25.5304 27.5 26.0391 27.2893 26.4142 26.9142C26.7893 26.5391 27 26.0304 27 25.5V17.5" />
      <path d="M13 14.5V23.5H19" />
      <path d="M24.5 8.99998C24.8978 8.60216 25.4374 8.37866 26 8.37866C26.5626 8.37866 27.1022 8.60216 27.5 8.99998C27.8978 9.39781 28.1213 9.93737 28.1213 10.5C28.1213 11.0626 27.8978 11.6022 27.5 12L20 19.5L16 20.5L17 16.5L24.5 8.99998Z" />
    </>
  );
}

/**
 * Design Package glyph — pencil on page, no tile. Drawn with lines, so the
 * colour comes from a `stroke-*` class in `className` (use `stroke-current`
 * to follow the surrounding text colour).
 */
export default function DesignPackageCiqIcon({
  size = 12,
  className = "stroke-black",
  opacity = "0.6"
}: {
  size?: number;
  className?: string;
  opacity?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="7 7 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeOpacity={opacity}
      >
        <DesignPackagePaths />
      </g>
    </svg>
  );
}

/**
 * Design Package badge — the same glyph on its fixed-colour tile.
 * Design: 36×36 container (#6F219D at 80%) + glyph (#EFC9F9). Used by CiqIconBox.
 */
export function DesignPackageTileCiqIcon({
  size = 36,
  className = ""
}: {
  size?: number;
  className?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g opacity="0.8">
        <rect width="36" height="36" rx="4" fill="#6F219D" />
        <g
          stroke="#EFC9F9"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <DesignPackagePaths />
        </g>
      </g>
    </svg>
  );
}
